import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { API_BASE_URL } from "../../environment";
import AuthCardLayout from "./AuthCardLayout";

const MySwal = withReactContent(Swal);

interface LocationState {
  email?: string;
}

const EmailVerification = () => {
  // grab the raw location object…
  const location = useLocation();
  // …and assert its state shape
  const state = (location.state as LocationState) ?? {};
  const email = state.email ?? "";

  const [isResending, setIsResending] = useState(false);

  const handleResendVerification = async () => {
    if (!email) {
      MySwal.fire({
        icon: "error",
        title: "Email Not Found",
        text: "Email address is not available. Please go back to registration.",
        showConfirmButton: true,
      });
      return;
    }

    setIsResending(true);

    try {
      const res = await fetch(`${API_BASE_URL}/user/resend-verification/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (!res.ok) throw new Error("Failed to resend verification email");

      const data = await res.json();

      MySwal.fire({
        icon: "success",
        title: "Verification Email Sent",
        text: data.message || "Verification email has been sent successfully. Please check your inbox.",
        showConfirmButton: true,
      });
    } catch (err) {
      console.error(err);
      MySwal.fire({
        icon: "error",
        title: "Failed to Send Verification Email",
        text: "Could not send verification email. Please try again.",
        showConfirmButton: true,
      });
    } finally {
      setIsResending(false);
    }
  };

  return (
    <AuthCardLayout
      icon="ti-mail-check"
      title="Verify Your Email"
      subtitle={
        email ? (
          <>
            We've sent a verification link to <strong className="text-dark text-break">{email}</strong>. Please follow
            the link to continue.
          </>
        ) : (
          `We've sent a verification link to your email ${email}. Please follow the link to continue.`
        )
      }
    >
      <p className="text-center text-muted mb-2">Didn't receive the email?</p>
      <button
        type="button"
        className="btn btn-outline-primary w-100 d-inline-flex align-items-center justify-content-center"
        onClick={handleResendVerification}
        disabled={isResending}
      >
        {isResending ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
            Sending link...
          </>
        ) : (
          <>
            <i className="ti ti-refresh me-2" />
            Resend Verification Link
          </>
        )}
      </button>
    </AuthCardLayout>
  );
};

export default EmailVerification;
